// Token validation and expiration utilities

export const isTokenExpired = (token) => {
  if (!token) return true;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Math.floor(Date.now() / 1000);
    
    if (payload.exp && payload.exp < currentTime) {
      return true;
    }
    
    return false;
  } catch {
    return true;
  }
};

export const getTokenExpirationTime = (token) => {
  if (!token) return null;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
};

// Add JWT payload extraction utilities
export const getTokenPayload = (token) => {
  if (!token) return null;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload;
  } catch {
    return null;
  }
};

export const getTokenPermissions = (token) => {
  const payload = getTokenPayload(token);
  return payload?.permissions || [];
};

export const hasPermission = (token, permission) => {
  const permissions = getTokenPermissions(token);
  return permissions.includes(permission);
};

export const hasAnyPermission = (token, requiredPermissions) => {
  const permissions = getTokenPermissions(token);
  return requiredPermissions.some(permission => permissions.includes(permission));
};

export const getUserRolesFromToken = (token) => {
  const payload = getTokenPayload(token);
  return payload?.roles || [];
};

export const getTimeUntilExpiration = (token) => {
  const expirationTime = getTokenExpirationTime(token);
  if (!expirationTime) return null;
  
  const currentTime = Date.now();
  const timeUntilExpiration = expirationTime - currentTime;
  
  return timeUntilExpiration > 0 ? timeUntilExpiration : 0;
};
